module.exports = __webpack_public_path__ + "img/tesla_600.21b80ec7.png";